import {
  CustomButton,
  CustomLabel,
  FlexContainer,
  UtilityMethods,
} from "@mindmemobile/mm-shared-global";
import React, { FC } from "react";
import {
  InvoiceDetailModel,
  RelatedPaymentsGridModel,
} from "../../../shared/models";
import {
  DescriptionCell,
  ItemDetailLeftPanel,
  ItemDetailRightPanel,
  LabelCell,
} from "../../../shared/styles";
import { InvoiceUtil } from "../../../shared/utils";
import { RenderPaymentMethod } from "../../../shared/components";
import { AccountSettingsStore } from "../../../shared/store";

type IProps = {
  data: InvoiceDetailModel;
  lastPayment?: RelatedPaymentsGridModel;
  className?: string;
};

const DetailSection: FC<IProps> = ({ data: item, lastPayment }) => {
  const row = (
    label: string,
    rightColumn: string | React.ReactNode,
    className?: string
  ): React.ReactNode => {
    return (
      <FlexContainer className="label-description-row">
        <LabelCell>
          <CustomLabel className={className}>{label}</CustomLabel>
        </LabelCell>
        <DescriptionCell>{rightColumn}</DescriptionCell>
      </FlexContainer>
    );
  };

  function getPaymentDescription() {
    if (!lastPayment) return null;

    if (lastPayment.isRefund) {
      return (
        (lastPayment.success ? " refunded " : " refund failed ") +
        UtilityMethods.formatDateInStringWithTime(lastPayment.createdDate)
      );
    }

    return (
      (lastPayment.success ? " paid " : " failed ") +
      UtilityMethods.formatDateInStringWithTime(lastPayment.createdDate)
    );
  }
  const colors = InvoiceUtil.getColorsByStatus(item.status);
  return (
    <FlexContainer>
      <ItemDetailLeftPanel>
        {row(
          "Status",
          <>
            <CustomButton
              minWidth={"90px"}
              padding="6px 10px"
              borderRadius="4px !important"
              color={colors.color}
              bgColor={colors.bgColor}
              className="status-btn"
            >
              {item.status}
            </CustomButton>
            {item.pastDueDays || ""}
          </>,
          "status-lh"
        )}
        {row("Invoice No", item.invoiceNumber)}
        {row(
          "Created",
          <CustomLabel>
            <>
              {(item.createdDate &&
                UtilityMethods.formatDateInStringWithTime(item.createdDate)) ||
                "-"}
            </>
          </CustomLabel>
        )}
        {row("Description", item.description)}
        {row("Invoice ID", item.id)}
        {row(
          "Amount",
          <CustomLabel fontWeight={"600"}>
            ${AccountSettingsStore.formatAmount(item.amount, true)}
          </CustomLabel>
        )}
        {row(
          "Discount",
          <CustomLabel color="#f00">
            ${AccountSettingsStore.formatAmount(0, true)}
          </CustomLabel>
        )}
        {row(
          "Credit",
          <CustomLabel color="#f00">
            ${AccountSettingsStore.formatAmount(item.totalCreditAmount, true)}
          </CustomLabel>
        )}
        {row(
          "Surcharge",
          <CustomLabel>
            ${AccountSettingsStore.formatAmount(0, true)}
          </CustomLabel>
        )}
        {row(
          "Paid",
          <CustomLabel>
            ${AccountSettingsStore.formatAmount(item.paidAmount, true)}
          </CustomLabel>
        )}
        {row(
          "Balance",
          <CustomLabel fontWeight={"600"}>
            ${AccountSettingsStore.formatAmount(item.balance, true)}
          </CustomLabel>
        )}
      </ItemDetailLeftPanel>
      <ItemDetailRightPanel>
        {" "}
        {row(
          "Payment Due",
          <CustomLabel>
            ${AccountSettingsStore.formatAmount(item.balance, true)}
          </CustomLabel>
        )}
        {row(
          "Date Due",
          <CustomLabel>
            <>
              {(item.dueDate &&
                UtilityMethods.formatDateInStringWithTime(item.dueDate)) ||
                "-"}
            </>
          </CustomLabel>
        )}
        {row(
          "Bill To",
          <FlexContainer fxLayout="column" spacing={5}>
            <CustomLabel color="#556BB8">
              {" "}
              {item.contact?.fullName || item.contact?.email}{" "}
            </CustomLabel>
            {/* <CustomLabel> {item.contact?.address} </CustomLabel> */}
          </FlexContainer>
        )}
        {row(
          "Payment Methods",
          <FlexContainer fxLayout="column" spacing={5}>
            <RenderPaymentMethod paymentMethod={item.paymentMethod} />
          </FlexContainer>
        )}
        {/* {row("Order No", <CustomLabel color="#556BB8"> 1001 </CustomLabel>)} */}
        {row(
          "Subscription No",
          <CustomLabel color="#556BB8"> {item.subscriptionNumber} </CustomLabel>
        )}
        {row(
          "Payments",
          <FlexContainer fxLayout="column" spacing={5}>
            {lastPayment && (
              <CustomLabel>
                <span className="text-royal-blue">
                  ${AccountSettingsStore.formatAmount(lastPayment.amount, true)}
                </span>
                {getPaymentDescription()}
              </CustomLabel>
            )}
            {/* <CustomLabel>
                          <span className="text-royal-blue"> </span> paid Nov 3, 2024
                      </CustomLabel> */}
            {/* <CustomLabel>
                          {' '}
                          <span className="text-royal-blue"> </span> refunded Nov 3, 2024
                      </CustomLabel> */}
          </FlexContainer>
        )}
        {row(
          "Merchant Account",
          <FlexContainer fxLayout="column" spacing={5}>
            <CustomLabel> {item.merchantAccount?.name}</CustomLabel>
          </FlexContainer>
        )}
      </ItemDetailRightPanel>
    </FlexContainer>
  );
};
export default DetailSection;
